import React from 'react'
import Typography from '@mui/material/Typography'

const defaultSx = {
  borderRadius: '50px',
  border: '1px solid #CBD6E6', /* Blue/100 */
  fontSize: '11px',
  lineHeight: '16px',
  height: '16px',
  fontWeight: 350,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  padding: '6px 8px',
  width: 'fit-content',
}

export enum PillVariant {
  NONE = 0,
  OPTIONAL,
}

export interface PillProps {
  label?: string
  sx?: object
  variant?: PillVariant
}

const variantProps = new Map<PillVariant, PillProps>([
  [PillVariant.OPTIONAL, {
    label: 'optional',
    sx: {
      ...defaultSx,
      color: '#45556C', /* Blue/700 */
    }
  }]
]);

/**
 * @param {PillProps} props
 * @param {string} props.label (Optional) text to display inside the pill (may not be needed if variant is used)
 * @param {object} props.sx (Optional) - To customize the look and feel if needed.
 * @param {PillVariant} props.variant (Optional) - Preset props for known types of pills, for uniformity across the app
 */

const Pill = ({ 
  label,
  sx,
  variant,
}: PillProps) => {

  if (!variant) {
    return (
      <Typography
        sx={{ ...defaultSx, ...sx }}
      >
          {label}
      </Typography>
    )
  }

  const { label: variantLabel, sx: variantSx } = variantProps.get(variant) as PillProps;
  return (
    <Pill label={variantLabel} sx={{...variantSx, ...sx}}/>
  )
}

Pill.defaultProps = {
  label: '',
  sx: {},
}



export default Pill
